import * as THREE from "three";
import { SetTreeTransArr, SetupObstUI } from "./TransControl";
import { ChangeTreeSize, SetObstPosition, ToggleSelectedTreeDelete, ChangeSelectedTreeShape, SetTreeSize } from "./ObstructionControl";
import {
    AddIndividualMode,
    SwitchModuleIrrMat
} from "./ModuleControl";
import { useViewerStore } from "../../../../../store/store";
import { drawDesign } from "./Loader";
import { UpdatePlaneRoof } from "./PlaneRoofControls";
import { addSelectedTree } from "../../../../../helpers/storeHelpers";
import { Viewer } from "../Viewer-Factory/Viewer";
import { CustomImageProperty, HideObjectType, ObstProperty, EditAction } from "../../../../../@types/enums";
export function InitStep(self: Viewer) {
    self.stepArr = [];
    self.stepMax = -1;
    self.stepNum = -1;
    SetStepButton(self.stepMax, self.stepNum);
}

export function AddStep(self: Viewer, key: EditAction, object: any, older?: any, newer?: any) {
    self.stepNum++;
    self.stepArr[self.stepNum] = { key, object, older, newer };
    self.stepMax = self.stepNum;
    SetStepButton(self.stepMax, self.stepNum);
}

export function SetStep(self: Viewer, stepDir: number) {
    // const {stepArr, stepNum, stepMax} = self;
    if (self.stepNum === -1 && stepDir === -1) return;
    if (self.stepNum === self.stepMax && stepDir === 1) return;
    const { treeGroup, obstGroup, roofRotY } = self;
    var stepInfo;
    if (stepDir === -1) {
        stepInfo = self.stepArr[self.stepNum];
    } else {
        stepInfo = self.stepArr[self.stepNum + 1];
    }
    if (!stepInfo) return;
    const { key, object, older, newer } = stepInfo;

    if (key === EditAction.WallHeight) {
        const wallHeight = (stepDir === -1 ? older : newer);
        self.setWallSize(wallHeight);
        useViewerStore.setState({ wallEditedHeight: wallHeight });
    } else if (key.includes('customImage')) {
        const realKey = GetPropertyName(key) as CustomImageProperty;
        const stepValue = stepDir === -1 ? older : newer;
        self.updateCustomImageProperty(realKey, stepValue);
    } else if (key === EditAction.GhostTree) {
        const selGroup = (stepDir === -1 ? older : newer);
        const selGroupIds = selGroup.map((group: any) => group.obstId);
        if (useViewerStore.getState().isHideAllGhostTrees) {
            self.hideObject(HideObjectType.GhostTree, !useViewerStore.getState().isHideAllGhostTrees);
            useViewerStore.setState({ isHideAllGhostTrees: !useViewerStore.getState().isHideAllGhostTrees });
        }
        self.selTreeArr = treeGroup.children.filter((group: any) => selGroupIds.includes(group.obstId));
        ToggleSelectedTreeDelete(self)
    } else if (key === EditAction.GhostTreeAndCart) {
        const selGroup = (stepDir === -1 ? older : newer);
        const selGroupIds = selGroup.treeArr.map((group: any) => group.obstId);
        if (useViewerStore.getState().isHideAllGhostTrees) {
            self.hideObject(HideObjectType.GhostTree, !useViewerStore.getState().isHideAllGhostTrees);
            useViewerStore.setState({ isHideAllGhostTrees: !useViewerStore.getState().isHideAllGhostTrees });
        }
        self.selTreeArr = treeGroup.children.filter((group: any) => selGroupIds.includes(group.obstId));
        ToggleSelectedTreeDelete(self)
        useViewerStore.setState({ treeCartItems: selGroup.cartArr });
    } else if (key === EditAction.GhostObstruction) {
        // const delStatus = (stepDir === -1 ? older : newer);
        self.obstId = object;
        self.setObstDelete();
    } else if (key === EditAction.TreeShape) {
        const treeType = (stepDir === -1 ? older : newer);
        object.forEach((treeId: any, idx: number) => {
            const selTree = treeGroup.children.find((tree: any) => tree.obstId === treeId);
            if (!selTree) return;
            let currentType = treeType[idx] || "crown1"
            ChangeSelectedTreeShape(self, currentType)
        });
    } else if (key === EditAction.ObstMove) {
        const obstObj = obstGroup.children.find((obst: any) => {
            return obst.obstId === object
        });
        const stepValue = stepDir === -1 ? older : newer;
        if (!obstObj) return;
        SetObstPosition(obstObj, stepValue, roofRotY);
        self.refreshShade();
    } else if (key === EditAction.TreeMove) {
        object.forEach((treeId: any, idx: number) => {
            const selTree = treeGroup.children.find((tree: any) => {
                return String(tree.obstId) === String(treeId);
            });
            if (!selTree) return;
            const oldPos = older[idx], newPos = newer[idx];
            const stepValue = stepDir === -1 ? oldPos : newPos;
            selTree.position.set(stepValue.x, stepValue.y, stepValue.z);
        });
        SetTreeTransArr(self);
        self.refreshShade();
    }
    else if (key === EditAction.ObstCreate) {
        const index = obstGroup.children.findIndex((obst: any) => obst.obstId === object.obstId);
        if (index !== -1) {
            obstGroup.children.splice(index, 1);
        } else {
            obstGroup.children.push(object);
        }
        self.refreshShade();
    } else if (key === EditAction.ObstAngle) {
        const selGroup: any = self.obstGroup.children.find((item: any) => item.obstId === object);
        const inGroup = selGroup.children[0].children[0];
        const obstMesh = inGroup.children[0]
        if (inGroup.rotation.x !== obstMesh.rotX) inGroup.rotation.x = obstMesh.rotX;
        obstMesh.verFloor = !obstMesh.verFloor
        self.refreshShade()
    } else if (key === EditAction.ObstShape) {
        const shapeNo = (stepDir === -1 ? older : newer);
        self.obstId = object;
        self.setObstShape(shapeNo);
        self.refreshShade();
    } else if (key === EditAction.TreeCreate) {
        const index = treeGroup.children.findIndex((tree: any) => tree.obstId === object.obstId);
        if (index !== -1) {
            treeGroup.children.splice(index, 1);
        } else {
            treeGroup.children.push(object);
        }
        self.refreshShade();
    } else if (key === EditAction.MaterialChange) {
        const selMeshArr: any[] = [];
        object.forEach((uuid: any) => {
            self.modelGroup.traverse((child: any) => {
                if (child.uuid === uuid) selMeshArr.push(child);
            });
        });
        selMeshArr.forEach((mesh, idx) => {
            const stepValue = stepDir === -1 ? older[idx] : newer[idx];
            const { map, color } = stepValue;
            if (map && !color) mesh.material = new THREE.MeshStandardMaterial({ map });
            else if (!map && color) mesh.material = new THREE.MeshStandardMaterial({ color });
        });
    } else if (key === EditAction.ModuleLayout) {
        const modeStr = (stepDir === -1) ? older : newer;
        useViewerStore.setState({ savedRoofModulesLayout: JSON.parse(modeStr) });
        const layout = useViewerStore.getState().savedRoofModulesLayout || [];
        const showLabel = useViewerStore.getState().isModuleMultiplierLabelVisible;
        // clear existing modules first
        self.roofMeshArr.forEach(roof => {
            roof.children.filter((c: any) => c.module).forEach((m: any) => {
                const idx = self.meshArr.findIndex(mm => mm.moduleId === m.moduleId);
                if (idx !== -1) self.meshArr.splice(idx, 1);
                const idx2 = self.moduleMeshArr.findIndex(mm => mm.moduleId === m.moduleId);
                if (idx2 !== -1) self.moduleMeshArr.splice(idx2, 1);
                roof.remove(m);
            });
        });
        layout.forEach((entry: any) => {
            const roofMesh = self.roofMeshArr.find(r => r.roofFaceId === entry.roofFaceId);
            if (!roofMesh) return;
            entry.moduleArr.forEach((item: any) => {
                AddIndividualMode(roofMesh, item, true, self.moduleMeshArr, self.meshArr, showLabel,true);
            });
        });
        SwitchModuleIrrMat(self, true);
        self.refreshShade();

    } else if (key === EditAction.TogglePathway) {
        self.togglePathway(object);
    } else if (key === EditAction.MapMove) {
        const position = (stepDir === -1) ? older : newer;
        self.mapCustom?.position.set(position.x, position.y, position.z);
    } else if (key === EditAction.DrawFace || key === EditAction.DeleteFace) {
        const roofs = self.roofs[0];
        if ((stepDir === -1 && key === EditAction.DrawFace) || (stepDir === 1 && key === EditAction.DeleteFace)) {
            // Undo face creation/ Redo face deletion -> Remove new face & edges
            roofs.faces = roofs.faces.filter((item: any) => item.roofFaceId !== object.newFace.roofFaceId);
            roofs.edges = roofs.edges.filter((item: any) => item.roofFaceId !== object.newFace.roofFaceId);
        } else {
            // Undo face deletion/ Redo face creation -> Add new face & edges
            roofs.faces.push(object.newFace);
            roofs.edges.push(...object.newEdges);
        }
        drawDesign(self);
        SwitchModuleIrrMat(self, true);
        self.refreshShade();
    } else if (key === EditAction.UpdatePlaneRoof) {
        const { property, selRoofId } = object;
        const value = (stepDir === -1) ? older : newer;
        self.selFlatRoof = self.roofMeshArr.find(item => item.roofFaceId === selRoofId) || null;
        UpdatePlaneRoof(self, property, value, true);
    } else if (key.includes('Obst')) {
        const realKey = GetPropertyName(key);
        const stepValue = stepDir === -1 ? older : newer;
        self.obstId = object;
        self.setObstProperty(realKey as ObstProperty, stepValue[0])
        useViewerStore.setState({ obstUpdated: !useViewerStore.getState().obstUpdated });
        SetupObstUI(self, object);
        self.refreshShade();
    } else if (key.includes('Tree')) {        
        // const selectedTrees: any = treeGroup.children.filter((tree: any) => object.includes(tree.obstId));
        // selectedTrees.forEach((t: any) => { t.select = true; });
        // useViewerStore.setState({selectedTrees: selectedTrees});
        // const selectedTrees: any = [];
        const trees = Array.isArray(object) ? object : [object];
        const stepValue = stepDir === -1 ? older : newer;
        const realKey = GetPropertyName(key);
        trees.forEach((obstId: any) => {
            const treeObj: any = treeGroup.children.find((tree: any) => tree.obstId === obstId);
            if (!treeObj) return;
            // Update the specific property on the tree object
            const crownMesh = treeObj.children[0];
            const { crownScl } = crownMesh;
            const trunkMesh = treeObj.children[1];
            if (realKey === 'height') treeObj.totalH = stepValue[0];
            const height = treeObj.totalH;
            const crown_radius = realKey === 'crown_radius' ? stepValue[0] : crownMesh.scale.x / crownScl.x;
            const crown_height = realKey === 'crown_height' ? stepValue[0] : crownMesh.scale.y / crownScl.y;
            const trunk_radius = realKey === 'trunk_radius' ? stepValue[0] : trunkMesh.scale.x;
            SetTreeSize(self, treeObj, { height, crown_radius, crown_height, trunk_radius });
            treeObj.select = true;
            addSelectedTree(treeObj);
        });
        SetTreeTransArr(self);
        ChangeTreeSize(self, realKey, stepValue);
        self.refreshShade();
    } 

    self.stepNum += stepDir;
    SetStepButton(self.stepMax, self.stepNum);
}

export function SetStepButton(stepMax: number, stepNum: number) {
    const btnStepUndo = document.getElementsByClassName('btnStepUndo')[0],
        btnStepRedo = document.getElementsByClassName('btnStepRedo')[0];
    if (stepNum > -1) btnStepUndo?.classList.remove('disabled');
    else btnStepUndo?.classList.add('disabled');
    if (stepNum === stepMax) btnStepRedo?.classList.add('disabled');
    else btnStepRedo?.classList.remove('disabled');
}

function GetPropertyName(stepKey: EditAction) {
    var realKey = ''
    if (stepKey.includes('customImage')) {
        const subKey = stepKey.substring(11);
        const firstStr = subKey.substring(0, 1), otherStr = subKey.substring(1);
        realKey = firstStr.toLowerCase() + otherStr;
    } else if (stepKey.includes('Obst')) {
        realKey = stepKey.substring(4).toLowerCase();
    } else if (stepKey.includes('Tree')) {
        if (stepKey === EditAction.TreeHeight) realKey = 'height';
        else if (stepKey === EditAction.TreeCrownDiameter) realKey = 'crown_radius';
        else if (stepKey === EditAction.TreeCrownHeight) realKey = 'crown_height';
        else if (stepKey === EditAction.TreeTrunkRadius) realKey = 'trunk_radius';
    }
    return realKey
}